import React from 'react'
import '../../assets/css/nav.css'
const Mininavbar = (props) => {
    const { toggle } = props

    return(
        (toggle === true)?
            <div className="topnav responsive">
                <a href={"https://twitter.com/GqlxMusic"} target="_blank"><div className="nav_items">Twitter</div></a>
              
            </div>
            : null
    )
}
class Navbar extends React.PureComponent {
    constructor(){
        super();
        this.state  = {
            Nav: false,
        }
    }


    render() {
        return(
            <div className="topnav">
                <a href={"https://twitter.com/GqlxMusic"} target="_blank"><div className="nav_items">Twitter</div></a>
                <button className="icon" onClick={() => (this.setState({Nav: !this.state.Nav}))}>
                    <i className="fa fa-bars"></i>
                    <Mininavbar toggle={this.state.Nav} />
                </button>
            </div>
        )
    }
}

export default Navbar
